export default "__VITE_ASSET__C9fyOYQ6__"